// extracted by css-extract-rspack-plugin
export default {"aliceAppActionButton":"aliceAppActionButton__ur4PK"};